export const anmClassificationCatalogEnUS = {
  "sections": {
    "cri": {
      "label": "CRI",
      "subtitle": "1 - Risk classification"
    },
    "dpa": {
      "label": "DPA",
      "subtitle": "2 - Associated potential damage"
    },
    "go": {
      "label": "Operational management",
      "subtitle": "3 - Operational management"
    }
  },
  "grades": {
    "ct": {
      "fullTitle": "1.1 - Technical characteristics - CT"
    },
    "ec": {
      "fullTitle": "1.2 - Conservation condition - EC"
    },
    "psb": {
      "fullTitle": "1.3 - Dam safety plan - PSB"
    },
    "dpa": {
      "fullTitle": "2 - Classification by associated potential damage - DPA (waste and tailings)"
    },
    "go": {
      "fullTitle": "3 - Classification by operational management"
    }
  },
  "columns": {
    "ctA": {
      "title": "Height"
    },
    "ctB": {
      "title": "Average slope inclination in the main section"
    },
    "ctC": {
      "title": "Length"
    },
    "ctD": {
      "title": "Design flood"
    },
    "ctE": {
      "title": "Compaction control"
    },
    "ctF": {
      "title": "Existence of internal drainage"
    },
    "ctG": {
      "title": "Foundation"
    },
    "ctH": {
      "title": "Construction method"
    },
    "ctI": {
      "title": "Instrumentation"
    },
    "ctJ": {
      "title": "Dam age"
    },
    "ecK": {
      "title": "Reliability of spillway structures"
    },
    "ecL": {
      "title": "Seepage"
    },
    "ecM": {
      "title": "Deformations and settlements"
    },
    "ecN": {
      "title": "Deterioration of slopes / faces"
    },
    "ecO": {
      "title": "Surface drainage"
    },
    "psbP": {
      "title": "Design documentation"
    },
    "psbQ": {
      "title": "Organizational structure and qualification of professionals on the dam safety team"
    },
    "psbR": {
      "title": "Procedure manuals for safety inspections and monitoring"
    },
    "psbS": {
      "title": "Emergency Action Plan PAE (when required by the supervisory authority)"
    },
    "psbT": {
      "title": "Inspection and instrumentation monitoring reports and safety analysis reports"
    },
    "dpaA": {
      "title": "Total reservoir volume"
    },
    "dpaB": {
      "title": "Existence of downstream population"
    },
    "dpaC": {
      "title": "Environmental impact"
    },
    "dpaD": {
      "title": "Socioeconomic impact"
    },
    "goA": {
      "title": "RISR Stability Condition Statement submitted"
    },
    "goB": {
      "title": "RPSB Stability Condition Statement submitted"
    },
    "goC": {
      "title": "Conformity and Operationality Statement submitted"
    },
    "goD": {
      "title": "Inspection Extract submitted"
    },
    "goE": {
      "title": "Existence of EdR"
    },
    "goF": {
      "title": "Risk Management Program for Mining Dams — PGRBM"
    },
    "goG": {
      "title": "Certification and/or industry standards"
    }
  },
  "options": {
    "ctA": {
      "score0": "Height ≤ 15m",
      "score1": "15m < Height < 30m",
      "score4": "30m ≤ Height ≤ 60m",
      "score7": "Height > 60m"
    },
    "ctB": {
      "score0": "Gentle (≤ 1V:3H) or concrete dam",
      "score3": "Intermediate (1V:2H ≥ Inclination > 1V:3H)",
      "score6": "Steep (> 1V:2H)"
    },
    "ctC": {
      "score0": "Length ≤ 50m",
      "score1": "50m < Length < 200m",
      "score2": "200 ≤ Length ≤ 600m",
      "score3": "Length > 600m"
    },
    "ctD": {
      "score0": "CMP (Probable Maximum Flood) or ten-thousand-year event",
      "score2": "Thousand-year event",
      "score5": "TR = 500 years",
      "score10": "TR less than 500 years or unknown / unreliable study"
    },
    "ctE": {
      "score0": "Documents exist proving compaction control according to the design and proving technological monitoring and control during execution",
      "score4": "Geotechnical studies exist proving the degree of compaction according to the design",
      "score10": "No technological control was performed and/or there is no information and/or compaction is not in accordance with the design"
    },
    "ctF": {
      "score0": "Drainage built according to the design, or no drainage exists in the design",
      "score4": "Corrective drainage built after dam completion",
      "score10": "Drainage system not in accordance with the design, nonexistent, unknown, based on an unreliable study, or inoperative"
    },
    "ctG": {
      "score0": "Foundation investigated according to the design",
      "score6": "Foundation partially investigated",
      "score10": "Unknown foundation/unreliable study"
    },
    "ctH": {
      "score0": "Single stage",
      "score2": "Downstream raising",
      "score5": "Centerline raising",
      "score10": "Upstream raising or unknown"
    },
    "ctI": {
      "score0": "Instrumentation exists in accordance with the technical design",
      "score2": "Instrumentation exists but is not in accordance with the design, although instruments are being installed to meet the design",
      "score6": "Instrumentation exists but is not in accordance with the design, with no process to install instruments to meet the design",
      "score8": "Dam is not instrumented, contrary to the design"
    },
    "ctJ": {
      "score1": "Between 5 and 15 years",
      "score2": "Between 15 and 30 years",
      "score3": "< 5 years or > 30 years or no information"
    },
    "ecK": {
      "score0": "Civil structures well maintained and in normal operation /dam does not require spillway structures",
      "score3": "Structures with identified issues and corrective measures being implemented",
      "score6": "Structures with identified issues and without implementation of the required corrective measures, with no operational restriction and with spillway at full capacity",
      "score10": "Structures with identified issues, reduced spillway capacity, and no corrective measures"
    },
    "ecL": {
      "score0": "Seepage fully controlled by the drainage system",
      "score3": "Moisture or seepage in downstream areas, faces, slopes, and abutments that are stable and monitored",
      "score6": "Moisture or seepage in downstream areas, faces, slopes, or abutments without implementation of the required corrective measures",
      "score10": "Seepage in downstream areas with material transport, increasing flow, or infiltration of contained material, with potential to compromise structural safety"
    },
    "ecM": {
      "score0": "There are no deformations or settlements with potential to compromise structural safety",
      "score2": "Cracks and depressions exist with corrective measures being implemented",
      "score6": "Cracks and depressions exist without implementation of the required corrective measures",
      "score10": "Cracks, depressions, or slides exist, with potential to compromise structural safety"
    },
    "ecN": {
      "score0": "There is no deterioration of slopes and faces",
      "score2": "Failures in slope and face protection, presence of shrub vegetation",
      "score6": "Surface erosion, exposed reinforcement, presence of tree vegetation, without implementation of the required corrective measures.",
      "score10": "Pronounced depressions on slopes, slides, deep erosion gullies, with potential to compromise structural safety"
    },
    "ecO": {
      "score0": "Surface drainage exists and is operational",
      "score2": "Cracks and/or silting and/or depressions exist with corrective measures being implemented",
      "score4": "Cracks and/or silting and/or depressions exist without corrective measures being implemented",
      "score5": "Surface drainage does not exist"
    },
    "psbP": {
      "score0": "Executive design and \"as built\"",
      "score2": "Executive design or \"as built\"",
      "score3": "\"As is\" design",
      "score5": "Basic design",
      "score8": "Conceptual design",
      "score10": "No design documentation"
    },
    "psbQ": {
      "score0": "Has an administrative unit with a qualified technical professional responsible for dam safety, or the dam is not covered by items I, II, III, or IV of the sole paragraph of art. 1 of Law No. 12,334/2010",
      "score1": "Has a qualified technical professional (in-house or contracted) responsible for dam safety",
      "score3": "Has an administrative unit without a qualified technical professional responsible for dam safety",
      "score6": "Does not have an administrative unit and a qualified technical professional responsible for dam safety"
    },
    "psbR": {
      "score0": "Has procedure manuals for inspection, monitoring, and operation, or the dam is not covered by items I, II, III, or IV of the sole paragraph of art. 1 of Law No. 12,334/2010",
      "score2": "Has only a monitoring procedure manual",
      "score4": "Has only an inspection procedure manual",
      "score8": "Does not have manuals or formal procedures for monitoring and inspections"
    },
    "psbS": {
      "score0": "Has PAE",
      "score2": "Does not have PAE (not required by the supervisory authority)",
      "score4": "PAE under preparation",
      "score8": "Does not have PAE (when required by the supervisory authority)"
    },
    "psbT": {
      "score0": "Regularly issues inspection and monitoring reports based on instrumentation and safety analysis reports, or the dam is not covered by items I, II, III, or IV of the sole paragraph of art. 1 of Law No. 12,334/2010",
      "score2": "Regularly issues only safety analysis reports",
      "score4": "Regularly issues only inspection and monitoring reports",
      "score6": "Regularly issues only visual inspection reports",
      "score8": "Does not regularly issue inspection and monitoring reports and safety analysis reports"
    },
    "dpaA": {
      "score1": "Very small ≤ 500 thousand m³",
      "score2": "Small: 500 thousand to 5 million m³",
      "score3": "Medium: 5 million to 25 million m³",
      "score4": "Large: 25 million to 50 million m³",
      "score5": "Very large ≥ 50 million m³"
    },
    "dpaB": {
      "score0": "NONEXISTENT — there are no permanent/resident or temporary/transient people in the area affected downstream of the dam",
      "score3": "INFREQUENT — there are no people permanently occupying the area affected downstream of the dam, but there is a local-use rural road",
      "score5": "FREQUENT — there are no people permanently occupying the area affected downstream of the dam, but there is a municipal, state, or federal highway or other location and/or an enterprise with occasional human presence that may be affected",
      "score10": "EXISTING — there are people permanently occupying the area affected downstream of the dam; therefore, human lives may be affected"
    },
    "dpaC": {
      "score0": "INSIGNIFICANT — the area affected downstream of the dam is fully degraded from its natural conditions and the structure stores only Class II B - Inert waste, according to NBR 10004 (ABNT)",
      "score2": "LOW SIGNIFICANCE — the area affected downstream of the dam (has no relevant environmental interest area or protected areas under specific legislation, excluding APPs, and stores only Class II B - Inert waste, according to NBR 10004 (ABNT))",
      "score6": "SIGNIFICANT — the area affected downstream of the dam has relevant environmental interest or protected areas under specific legislation, excluding APPs, and stores only Class II B - Inert waste, according to NBR 10.004 (ABNT)",
      "score8": "VERY SIGNIFICANT — the dam stores tailings or solid waste classified as Class II A - Non-Inert, according to NBR 10004 (ABNT)",
      "score10": "AGGRAVATED VERY SIGNIFICANT — the dam stores tailings or solid waste classified as Class I - Hazardous, according to NBR 10.004 (ABNT)"
    },
    "dpaD": {
      "score0": "NONEXISTENT — there are no facilities in the area affected downstream of the dam",
      "score1": "LOW — there is a small concentration of residential, agricultural, industrial, or infrastructure facilities of cultural socioeconomic relevance in the area affected downstream of the dam",
      "score3": "MEDIUM — there is a moderate concentration of residential, agricultural, industrial, or infrastructure facilities of cultural socioeconomic relevance in the area affected downstream of the dam",
      "score5": "HIGH — there is a high concentration of residential, agricultural, industrial, or infrastructure facilities of cultural socioeconomic relevance in the area affected downstream of the dam"
    },
    "goA": {
      "score0": "Attesting stability over the last 3 years",
      "score1": "Attesting stability during the last semester",
      "score8": "Not attesting",
      "score10": "Not submitted"
    },
    "goB": {
      "score0": "Attesting stability over the last 5 years",
      "score1": "Attesting stability for the most recently submitted statement",
      "score8": "Not attesting",
      "score10": "Not submitted"
    },
    "goC": {
      "score0": "Attesting conformity over the last 3 years",
      "score1": "Attesting conformity during the last year",
      "score8": "Not attesting",
      "score10": "Not submitted"
    },
    "goD": {
      "score0": "Within legal deadlines and with no anomaly record score 4, 6, or 10 in EC during the last 2 years",
      "score1": "Within legal deadlines and with no anomaly record score 4, 6, or 10 in EC during the last semester",
      "score2": "Outside legal deadlines or within legal deadlines but with anomaly record score 4, 6, or 10 in EC during the last semester",
      "score6": "With submission pending during the last semester",
      "score10": "Not submitted more than 4 subsequent or interspersed extracts during the last semester"
    },
    "goE": {
      "score0": "A Record Engineer is contracted",
      "score1": "No Record Engineer is contracted (not required by the supervisory authority)",
      "score10": "No Record Engineer is contracted (when required by the supervisory authority)"
    },
    "goF": {
      "score0": "Has PGRBM",
      "score1": "Does not have PGRBM (not required by the supervisory authority)",
      "score4": "PGRBM under preparation",
      "score9": "Does not have PGRBM (when required by the supervisory authority)"
    },
    "goG": {
      "score0": "Has ISO 31.000 or adopts TSM or ICMM",
      "score1": "Does not have ISO 31.000 or does not adopt TSM or ICMM"
    }
  }
} as const;
